<template>
  <span v-if="visible" :style="metaStyle">
    【{{ durationLabel }}: {{ durationSec }} 秒 | 输入tokens：{{ chat.llmInputTokens }} | 输出tokens：{{ chat.llmOutputTokens }}<template v-if="showTtsChars"> | 合成字符：{{ ttsChars }}</template> 】
  </span>
</template>

<script>
/**
 * 对话行内展示的 LLM 耗时 / token / 合成字符（与后端 RJChat 字段一致）。
 * 默认样式与多数拨号/客户详情页一致；微信聊天页传 variant="wx"。
 */
export default {
  name: 'RjChatLlmMeta',
  props: {
    chat: {
      type: Object,
      required: true,
    },
    /** default：灰色小字；wx：蓝色（原 WxChat 样式） */
    variant: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    visible() {
      return this.chat && Number(this.chat.contentTag) === 1;
    },
    durationLabel() {
      return this.variant === 'wx' ? 'LLM生成耗时' : '耗时';
    },
    metaStyle() {
      if (this.variant === 'wx') {
        return { fontSize: '10px', color: '#409eff' };
      }
      return { fontSize: '10px', color: '#aaacc4' };
    },
    durationSec() {
      const d = this.chat && this.chat.llmProductionDuration;
      if (d == null || d === '') {
        return '0.000';
      }
      return (Number(d) / 1000).toFixed(3);
    },
    ttsChars() {
      const v = this.chat && this.chat.ttsBillingCharacters;
      if (v == null || v === '') {
        return 0;
      }
      return Number(v);
    },
    showTtsChars() {
      return Number(this.ttsChars) > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rj-chat-llm-meta/RjChatLlmMeta.vue